import React from 'react';
import { Plus } from 'lucide-react';

export interface GsHeaderProps {
  pageTitle: string;
  onAddClick?: () => void;
  addButtonLabel?: string;
  trailingSlot?: React.ReactNode;
}

export function GsHeader({ pageTitle, onAddClick, addButtonLabel, trailingSlot }: GsHeaderProps) {
  const showActions = trailingSlot != null || onAddClick != null;

  // `pageTitle` etait une prop REQUISE jamais rendue : cinq apps calculaient un
  // titre par route que rien n'affichait, et les onglets portaient tous le
  // `<title>` fige de leur `index.html` (E-20260901-gsheader-pagetitle-morte,
  // E-20260831-titre-page-fige). Le Modele D interdit le titre DANS le header
  // (UI_STANDARDS 44, 70-72) : son consommateur est l'onglet, pas le chrome.
  //
  // L'effet est pose AVANT le retour anticipe du filet : hub, admin et gest ne
  // passent pas de `trailingSlot`, donc un effet place plus bas ne tournerait
  // jamais chez eux — et c'est la regle des hooks, pas une preference.
  //
  // La restauration au demontage rend l'onglet a son titre d'origine quand on
  // sort du shell (deconnexion, ecran d'acces) : on n'est plus « dans » l'app.
  React.useEffect(() => {
    if (!pageTitle) return undefined;
    const previous = document.title;
    document.title = pageTitle;
    return () => {
      document.title = previous;
    };
  }, [pageTitle]);

  // Modèle D — pas de titre dans le header
  // bg-slate-50 light / dark:bg-slate-900 dark — filet bottom
  if (!showActions) {
    return (
      <div className="h-px shrink-0 bg-slate-200 dark:bg-slate-800" />
    );
  }

  return (
    <header className="flex h-10 min-h-10 shrink-0 items-center justify-end px-5
                       bg-page dark:bg-slate-900
                       border-b border-slate-200 dark:border-slate-800">
      <div className="flex shrink-0 items-center gap-2">
        {trailingSlot}
        {onAddClick != null && (
          <button
            type="button"
            onClick={() => onAddClick()}
            className="inline-flex h-7 items-center justify-center rounded-md
                       border border-brand-200 bg-brand-50 px-2.5
                       text-meta font-medium text-brand-700
                       transition-colors hover:bg-brand-100
                       dark:border-brand-900/40 dark:bg-brand-950/40 dark:text-brand-300"
            title="Ajouter"
          >
            {addButtonLabel != null && addButtonLabel !== '+' ? (
              addButtonLabel
            ) : (
              <Plus className="h-3.5 w-3.5 shrink-0" strokeWidth={2.5} />
            )}
          </button>
        )}
      </div>
    </header>
  );
}
